import * as React from 'react';
import { useContext } from 'react';
import Menu from "@mui/material/Menu";
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from "react-router-dom";
import ListItemIcon from '@mui/material/ListItemIcon';
import Link from '@mui/material/Link';
import Logout from '@mui/icons-material/Logout';
import Password from '@mui/icons-material/Password';
//import { AuthContext } from 'global/context/authContextDefinition';
import { useAuth } from 'global/context/AuthProviderV2';



// ✅ Definir una interfaz para las props de LoggedInMenu
interface LoggedInMenuProps {
    handleLogout: () => void;
    handleClick: (event: React.MouseEvent<HTMLElement>) => void;
    anchorEl: HTMLElement | null;
    open: boolean;
    handleClose: () => void;
}

// ✅ Modifica `LoggedInMenu` para usar la interfaz correcta
const LoggedInMenu: React.FC<LoggedInMenuProps> = ({ handleLogout, handleClick, anchorEl, open, handleClose }) => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Typography style={{ cursor: "pointer" }} sx={{ minWidth: 100 }} onClick={() => navigate(`/`)}>Home</Typography>
                <Typography style={{ cursor: "pointer" }} sx={{ minWidth: 100 }} onClick={() => navigate(`/proyectos`)}>Proyectos</Typography>
                <Typography style={{ cursor: "pointer" }} sx={{ minWidth: 100 }} onClick={() => navigate(`/modelo`)}>Modelo KTH</Typography>
                <Typography
                    component="a"
                    href="/glosario"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ minWidth: 100, cursor: "pointer", textDecoration: "none", color: "inherit" }}
                >
                    Glosario
                </Typography>

                <Tooltip title="Account settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar sx={{ width: 32, height: 32 }}>
                            <div className="container-profile-picture-investigador">
                                <img
                                    src={`/avatar/s.jpg`}
                                    alt="Profile card investigador"
                                    onError={(e: any) => {
                                        e.target.onerror = null;
                                        e.target.style.maxWidth = "54px";
                                        e.target.src =
                                            "https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fzancada.com%2Fwp-content%2Fimagenes%2F2012%2F12%2Ffacebook-profile-picture-n-copy.jpg&f=1&nofb=1";
                                    }}
                                />
                            </div>
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem style={{ cursor: "pointer" }} onClick={() => navigate(`/cambiarpassword`)}>
                    <ListItemIcon>
                        <Password fontSize="small" />
                    </ListItemIcon>
                    Cambiar contraseña
                </MenuItem>
                <MenuItem style={{ cursor: "pointer" }} onClick={handleLogout}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

// ✅ Componente para usuarios NO logeados
const LoggedOutMenu = () => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Typography style={{ cursor: "pointer" }} sx={{ minWidth: 100 }} onClick={() => navigate(`/modelo`)}>Modelo KTH</Typography>
                <Typography style={{ cursor: "pointer" }} sx={{ minWidth: 100 }} onClick={() => navigate(`/login`)}>
                    <Link>Iniciar sesión</Link>
                </Typography>
            </Box>
        </React.Fragment>
    );
};

// ✅ Componente principal `AccountMenu`
export const AccountMenu = () => {
    //const authContext = useContext(AuthContext);
    const { isAuthenticated, user, logout } = useAuth();

    

    //const { user, signOut } = authContext;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [, forceUpdate] = React.useState(0); // ✅ Forzar re-render

    React.useEffect(() => {
        //console.log("user en menu:", JSON.stringify(user));
    }, [user]);

    const navigate = useNavigate();
    
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        await logout();
        forceUpdate((n) => n + 1); // ✅ Forzamos un re-render del componente
        navigate('/login');
    };

    return (
        <div>
            {isAuthenticated ? (
                <LoggedInMenu
                    handleLogout={handleLogout}
                    handleClick={handleClick}
                    anchorEl={anchorEl}
                    open={open}
                    handleClose={handleClose}
                />
            ) : (
                <LoggedOutMenu />
            )}
        </div>
    );
};